import {useHistoryMaterialsById} from '@domain/materials'
import {useUpmPlantContext} from '@hconnect/upm'
import {dataTestId} from '@hproduce/suite-core'
import {Grid, Skeleton} from '@mui/material'
import {usePlanningChartStartEnd} from '@widgets/planning-schedule-chart'

import {OptimizerStockLevelIndicator} from '../OptimizerStockLevelIndicator'
import {useGetOptimizedMaterialIds} from '../utils/useGetOptimizedMaterialIds'

const getSiloLevelsSkeletons = (amount: number) => {
  return Array.from({length: amount}, (_, index) => (
    <Grid item xs={12} md={6} key={index}>
      <Skeleton variant="rectangular" />
    </Grid>
  ))
}

export const OptimizerStockLevelsSummary = () => {
  const {plantId: plantCode} = useUpmPlantContext()
  const {startOfPlan, endOfPlan} = usePlanningChartStartEnd()
  const {data: materialsById} = useHistoryMaterialsById({
    plantId: plantCode,
    timeFrame: [startOfPlan, endOfPlan]
  })

  const optimizedMaterialIds = useGetOptimizedMaterialIds(plantCode)

  const shouldShow = materialsById && optimizedMaterialIds

  return (
    <>
      <Grid container spacing={4} mt={1} {...dataTestId('optimizer_stock_levels_summary')}>
        {shouldShow && optimizedMaterialIds !== undefined
          ? optimizedMaterialIds.map((materialId, index) => (
              <Grid
                item
                xs={12}
                md={6}
                key={`${materialId}_${index}_card`}
                {...dataTestId(`optimizer_stock_levels_${materialId}`)}
              >
                <OptimizerStockLevelIndicator
                  plantCode={plantCode}
                  material={materialsById[materialId]}
                />
              </Grid>
            ))
          : getSiloLevelsSkeletons(6)}
      </Grid>
    </>
  )
}
